export default __webpack_public_path__ + "static/media/loginBG.a9e717ad.jpg";